import { render, staticRenderFns } from "./CurrencySetting.vue?vue&type=template&id=b7f5dfb4"
import script from "./CurrencySetting.vue?vue&type=script&lang=js"
export * from "./CurrencySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7f5dfb4')) {
      api.createRecord('b7f5dfb4', component.options)
    } else {
      api.reload('b7f5dfb4', component.options)
    }
    module.hot.accept("./CurrencySetting.vue?vue&type=template&id=b7f5dfb4", function () {
      api.rerender('b7f5dfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/CurrencySetting.vue"
export default component.exports